import React, { useEffect, useState } from "react";
import ScrollContainer from "react-indiana-drag-scroll";

import { useTranslation } from "utils";

import { Col, ErrorBoundary, Form, InputSearch, Row } from "components";

export const SearchInput = ({ dataTestId, initial, type, search, suggestions }) => {
  const form = React.createRef();
  const { t } = useTranslation(["search"]);

  const [currentSearch, setCurrentSearch] = useState(false);

  const filteredSuggestions = suggestions.filter((suggestion) => suggestion[type]);

  useEffect(() => {
    if (currentSearch !== initial) {
      setCurrentSearch(initial);

      if (form.current) {
        form.current.setFieldsValue({
          search: initial,
        });
      }
    }
  }, [form, initial, currentSearch]);

  let suggestionCount = 0;

  return (
    <ErrorBoundary>
      <div className="search-container">
        <Row gutter={[{ xs: 8, sm: 8, md: 16 }, 0]}>
          <Col>
            <Form name="searchForm" ref={form}>
              <InputSearch
                dataTestId={dataTestId}
                name="search"
                initialValue={initial}
                key={initial}
                label={t(`placeholder.${type}`)}
                onChange={(e) => search(e.target.value)}
                className="margin-0 margin-top-100 margin-bottom-100"
              />
            </Form>
          </Col>
        </Row>
        {filteredSuggestions && filteredSuggestions.length > 0 && !initial && type !== "courses" && (
          <Row gutter={[{ xs: 8, sm: 8, md: 16 }, 0]}>
            <Col>
              <div className="suggestion-container">
                <div className="scroll-container">
                  <ScrollContainer className="suggestions">
                    <span className="paragraph-xs grey-text">{t("suggestions")}</span>
                    {filteredSuggestions.map((item, i) => {
                      if (suggestionCount < 8 && ((item.community && type === "community") || (item.articles && type === "articles"))) {
                        suggestionCount += 1;
                        return (
                          <span className="paragraph-xs grey-600-text" onClick={() => search(item.tag)} key={i}>
                            {item.tag}
                          </span>
                        );
                      }
                      return null;
                    })}
                  </ScrollContainer>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    </ErrorBoundary>
  );
};
